import { AddDynamicFunctionNameCell } from './AddDynamicFunctionNameCell'
import { AddDynamicFunctionValueCell } from './AddDynamicFunctionValueCell'
import type {
  SubTemplateAddDynamicFunctionFields,
  TemplateVersionAddDynamicFunctionFields,
} from './types'

type Props = {
  column: number
} & (
  | SubTemplateAddDynamicFunctionFields
  | TemplateVersionAddDynamicFunctionFields
)

export const AddDynamicFunctionCell = ({ column, ...other }: Props) => {
  switch (column) {
    case 0:
      return <AddDynamicFunctionNameCell />
    case 1:
      return <AddDynamicFunctionValueCell {...other} />
    default:
      throw new Error(
        `Unsupported column index ${column} for the add new dynamic function placeholder`,
      )
  }
}
